type Item = { _id: string } | null;

export const withItem = <T extends Item>(
  items: readonly T[] | null | undefined,
  item: NonNullable<T>,
  atStart = false,
) => {
  const list = items ?? [];
  if (list.some(existing => existing?._id === item._id)) {
    return [...list];
  }
  return atStart ? [item, ...list] : [...list, item];
};

export const withoutItem = <T extends Item>(items: readonly T[] | null | undefined, id: string) =>
  (items ?? []).filter(item => item?._id !== id);
